document.addEventListener("DOMContentLoaded", function () {
    setInterval(function () {
        var swiper = new Swiper(".mySwiperproduct", {
            slidesPerView: 3,
            spaceBetween: 0,
          pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
       breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 0
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 0
    }, 1100: {
      slidesPerView: 3,
      spaceBetween: 0
    }
  }
        });
    }, 3000);




    // Toggle description
document.querySelectorAll('.toggle-des-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    const parent = this.closest('.description-content');
    if (parent) {
      parent.classList.toggle('show-des-pro');
    }
  });
});

// Toggle rows
document.querySelectorAll('.toggle-rows-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    const parent = this.closest('.main-pro-title');
    if (parent) {
      parent.classList.toggle('show-title-pro');
    }
  });
});

  const productContent = document.querySelector(".site-box.box__product-content");
  if (!productContent) return;

  // Unique variable for content height
  const productContentHeight = productContent.offsetHeight;

  // Scroll listener (handles both conditions)
  window.addEventListener("scroll", function () {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    // First condition
    if (scrollPosition >= productContentHeight) {
      productContent.classList.add("activescroll");
    } else {
      productContent.classList.remove("activescroll");
    }

    // Second condition
    if (scrollPosition >= 125) {
      productContent.classList.add("activescrollnew");
    } else {
      productContent.classList.remove("activescrollnew");
    }
  });

if (window.innerWidth > 992) {
    const recommendations = document.querySelector(".shopify-section-product-recommendations");
    const gallery = document.querySelector(".product-gallery");
    const sidebar = document.querySelector(".box__product-content");

    if (recommendations && gallery && sidebar) {
      // Move recommendations right after .product-gallery
      gallery.insertAdjacentElement("afterend", recommendations);

      // Wrap .product-gallery and recommendations inside recommendations-gallery
      const wrapperGallery = document.createElement("div");
      wrapperGallery.classList.add("recommendations-gallery");
      gallery.parentNode.insertBefore(wrapperGallery, gallery);
      wrapperGallery.appendChild(gallery);
      wrapperGallery.appendChild(recommendations);

      // Wrap recommendations-gallery and sidebar inside recommendations-gallery-main
      const wrapperMain = document.createElement("div");
      wrapperMain.classList.add("recommendations-gallery-main");
      wrapperGallery.parentNode.insertBefore(wrapperMain, wrapperGallery);
      wrapperMain.appendChild(wrapperGallery);
      wrapperMain.appendChild(sidebar);
    }
  }
});